module.exports = __webpack_public_path__ + "img/ff03d.7881244c.svg";